import { Tooltip } from '@mui/material';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';

export const SortableActionButton = ({ id, tooltipText, children }: { id: string; tooltipText: string; children: React.ReactNode }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
        {children}
      </div>
    </Tooltip>
  );
};
